module.exports = __webpack_public_path__ + "img/img7.c2c25117.jpg";